// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const HiveButton = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M20,32A12,12,0,1,1,32,20,12.06,12.06,0,0,1,20,32ZM20,9A11,11,0,1,0,31,20,11.06,11.06,0,0,0,20,9Z" />
            <Path d="M31.54,36H8.46A4.46,4.46,0,0,1,4,31.54V8.46A4.46,4.46,0,0,1,8.46,4H31.54A4.46,4.46,0,0,1,36,8.46V31.54A4.46,4.46,0,0,1,31.54,36ZM8.46,5A3.46,3.46,0,0,0,5,8.46V31.54A3.46,3.46,0,0,0,8.46,35H31.54A3.46,3.46,0,0,0,35,31.54V8.46A3.46,3.46,0,0,0,31.54,5Z" />
        </G>
    );
    /*eslint-enable max-len */
};

export default HiveButton;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/hive-button/index.js